<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        <p>Start Workflow</p>
        <i id="ibtnClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content style="margin-top:10%">
    <br>
    <div style="width :100%;" *ngIf="isShowCopyBtn"><button style="float: right; margin-bottom: 1%;margin-right: 1%;"
            class="btn btn-primary" (click)="copyMembers()"><i class="fa fa-copy" (click)="copyValues()"
                aria-hidden="true" id="btnCopy2"></i>&nbsp;&nbsp;Copy All</button></div>
    <div style="width: 100%;clear: both;" class="eip-mxy-5">
        <mat-dialog-content>
            <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
                <form [formGroup]="roleMemberForm">
                    <div formArrayName="roles">
                        <kendo-grid #dciToStartWorkflowGrid [kendoGridBinding]="dciToStartWorkflow"
                            [reorderable]="false" [sortable]="false" [resizable]="true" [pageable]="false">
                            <kendo-grid-column title="Sl.No." filterable="false" [width]="60" [locked]="true">
                                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                    {{rowIndex+1}}
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Document No" field="documentNumber" [width]="200" [locked]="true">
                                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                    <span class="role-feature-label" eipTooltip="{{dataItem.documentNumber}}"
                                        eipTooltipPosition="auto">
                                        {{dataItem.documentNumber}}
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Title" field="documentTitle" [width]="200" [locked]="true">
                                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                    <span class="role-feature-label" eipTooltip="{{dataItem.documentTitle}}"
                                        eipTooltipPosition="auto">
                                        {{dataItem.documentTitle}}
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Revision" field="revisionNumber" [width]="70" [locked]="true">
                                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                    <span class="role-feature-label" eipTooltip="{{dataItem.revisionNumber}}"
                                        eipTooltipPosition="auto">
                                        {{dataItem.revisionNumber}}
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column-group title="Role & Member Details"
                                [headerStyle]="{ 'justify-content':'center' }">
                                <kendo-grid-column [width]="1">
                                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column filterable="false" [width]="100" field="documentNumber"
                                    *ngFor="let role of DciWorkflowStage; let index = index">
                                    <ng-template kendoGridHeaderTemplate let-dataItem>
                                        <span class="eip-ml-5">{{role.roleDescription}}</span>
                                    </ng-template>
                                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                        <span *ngFor="let data of members;">
                                            <span *ngIf="dataItem.documentId == data.docId">
                                                <span *ngFor="let stages of data.roleMembersMapping;">
                                                    <span *ngIf="stages.roleDescription == role.roleDescription">
                                                        <ng-template *ngIf="stages.roleMembersMapping.length <= 0"
                                                            kendoGridCellTemplate let-dataItem>
                                                            <span style="word-wrap: break-word;"
                                                                title="Workflow associated for the selected document(s) has been configured for members only, hence no role(s) to be displayed here. Please click 'Save' to start workflow.">Workflow
                                                                associated for the selected document(s) has been
                                                                configured for members only, hence no role(s) to be
                                                                displayed here.<br />Please click "Save" to start
                                                                workflow.</span>
                                                        </ng-template>
                                                        <EIPMultiSelectAutoComplete
                                                            [dataSource]="stages.roleMembersMapping"
                                                            ShowTextValueField='N' setId="stages.roleId"
                                                            TextField="memberName" ValueField="memberId" #multiSelecte
                                                            [setId]="stages.roleId"
                                                            [defaultSelectedValues]="stages?.selectedMemberId"
                                                            (valueChange)="onChange_Member($event, dataItem.documentId, dataItem.revisionNumber, stages.roleId,null,role.roleDescription,data.index,'manual')"
                                                            [width]="100">
                                                        </EIPMultiSelectAutoComplete>
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                    </ng-template>
                                </kendo-grid-column>
                            </kendo-grid-column-group>
                        </kendo-grid>
                    </div>
                </form>
            </div>
        </mat-dialog-content>
        <div class="notification" style="margin-left: 1%;">★&nbsp;Member(s) are listing based on their role and
            discipline mapping.</div>
    </div>
</div>
<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
        <button class="btn btn-primary" id="btnSave" (click)="onClick_Save()"><i class="fa fa-process-flow"
                aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Start Workflow</button>
        <button class="btn btn-secondary" id="btnReset" (click)="onClick_Reset()"><i class="fa fa-reset"
                aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Reset</button>
    </div>
</div>